export function Debug() {
  throw new Error("Boo!");
  return null;
}
